import getTransportDatesSaga from './getTransportDates';
import getTransportLocationsSaga from './getTransportLocations';
import getTransportOutboundStopsSaga from './getTransportOutboundStops';
import getTransportReturnStopsSaga from './getTransportReturnStops';
import getTransportRoutesSaga from './getTransportRoutes';
import getTransportStopsSaga from './getTransportStops';

export const transportSagas = [
  getTransportDatesSaga,
  getTransportLocationsSaga,
  getTransportStopsSaga,
  getTransportOutboundStopsSaga,
  getTransportReturnStopsSaga,
  getTransportRoutesSaga,
];
